import { Link, Pill } from "@foris/avocado-suite";
import { useTranslation } from "react-i18next";
import EditableTableCell from "../editable-table-cell";
import SessionTableTooltip from "../session-table-tooltip";
import styles from "./sessionResourceCell.module.scss";

interface SessionResourceCellProps {
  items: readonly { name?: string; code?: string }[];
  disabled: boolean;
  emptyLabel: string;
  onClick: () => void;
}

const SessionResourceCell = ({
  items,
  disabled,
  emptyLabel,
  onClick,
}: SessionResourceCellProps) => {
  const { t } = useTranslation();
  if (!items.length)
    return disabled ? (
      <span className={styles.empty}>{emptyLabel}</span>
    ) : (
      <Link iconLeft="plus" onClick={onClick}>
        {t("assignation-edit.session-view.assign")}
      </Link>
    );
  const [first, ...rest] = items;
  return (
    <div className={styles.sessionResourceCell}>
      <EditableTableCell disabled={disabled} onClick={onClick}>
        <span className={styles.label}>{first.name ?? first.code}</span>
      </EditableTableCell>
      {rest.length > 0 && (
        <SessionTableTooltip
          label={
            <ul className={styles.resourceList}>
              {items.map((item, index) => (
                <li key={index}>{item.name ?? item.code}</li>
              ))}
            </ul>
          }
          triggerClassName={styles.resourceCount}
          focusable
        >
          <Pill className={styles.pill}>+{rest.length}</Pill>
        </SessionTableTooltip>
      )}
    </div>
  );
};

export default SessionResourceCell;
